import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instituteRequest'
import ErrorMessage from 'utils/ErrorMessage'

import {
  setStudentData,
  setResumeData,
  setCampusDetails,
} from 'modules/Onboarding/actions'
import authRequest from 'utils/authRequest'
import { setExternalAppliedEventData } from '../Onboarding/actions'
import corporateRequest from 'utils/corporateRequest'
import searchRequest from 'utils/searchRequest'
import elasticSearchSyncRequest from '../../utils/elasticSearchSyncRequest'
import moment from 'moment'
const currentDate = moment().format('YYYY-MM-DD'); 

export const setPromotionData = data => {
  return {
    type: 'SET_PROMOTION_DATA',
    data,
  }
}

export const setListOfPerfCity = data => {
  return {
    type: 'SET_LIST_OF_PERF_CITY',
    data,
  }
}

export const setCorporateMasterList = data => {
  return {
    type: 'SET_CORPORATE_MASTER_LIST',
    data,
  }
}

export const setListOfCollege = data => {
  return {
    type: 'SET_COLLEGE_LIST',
    data,
  }
}

export const setListOfCollegeData = data => {
  return {
    type: 'SET_LIST_OF_COLLEGE_DATA',
    data,
  }
}

async function storeImageInLocalStorage(imageURL) {
  try {
    const response = await fetch(imageURL)
    const blob = await response.blob()
    const reader = new FileReader()
    reader.onloadend = () => {
      const base64Image = reader.result
      localStorage.setItem('imageData', base64Image)
    }
    reader.readAsDataURL(blob)
  } catch (error) {
    console.error('Failed to store image:', error)
  }
}

export const getPromotion = studentId => async (dispatch, getState) => {
  const state1 = getState()
  try {
    const response = await studentRequest.get(
      `/students/${state1?.auth?.studentId}/promotion`
    )
    dispatch(setPromotionData(response.data.data))
  } catch (error) {
    //console.log('Error in getting promotion data', error)
  }
}

export const getStudentData = () => async (dispatch, getState) => {
  const state1 = getState()
  try {
    const response = await studentRequest.get(
      `/students/${state1?.auth?.studentId}`
    )
    if (
      response.data?.data?.lastAppliedEventIds?.length
    ) {
      let lastAppliedEventIds = response?.data?.data?.lastAppliedEventIds?.[0]
      const mappedEVent = await instituteRequest.get(
        `/institutes/events/${lastAppliedEventIds}?studentId=${state1?.auth?.studentId}`
      )
      if (mappedEVent?.data?.data) {
        dispatch(setExternalAppliedEventData(mappedEVent.data.data))
      } else {
        dispatch(setExternalAppliedEventData(null))
      }
    }

    if (
      response.data?.data?.lastAppliedJobIds?.length
    ) {
      let lastAppliedJobIds = response?.data?.data?.lastAppliedJobIds?.[0]
      const mappedEVent = await corporateRequest.get(
        `/corporate/role/${lastAppliedJobIds}/${state1?.auth?.studentId}`
      )
      if (mappedEVent?.data?.data) {
        dispatch(setExternalAppliedEventData(mappedEVent.data.data))
      } else {
        dispatch(setExternalAppliedEventData(null))
      }
    }

    dispatch(setStudentData(response.data.data))

    let state = getState()
    const imageData = localStorage.getItem('imageData')
    if (!imageData) {
      storeImageInLocalStorage(state?.studentData?.studentDetails?.profileUrl)
    }
    dispatch(
      setResumeData({
        ...state?.studentData?.studentEditData,
        admin: {
          ...state?.studentData?.studentEditData?.admin,
          gender: state?.studentData?.studentDetails?.admin?.gender,
        },
      })
    )
    return response?.data?.data || {}
  } catch (error) {
    //console.log('Error in getting student data', error)
  }
}

export const updateStudentData = data => async (dispatch, getState) => {
  const state1 = getState()

    try {
      await studentRequest.put(`/students/${state1?.auth?.studentId}`, data)

      const payload = {
        "query_date": currentDate
    }
      await elasticSearchSyncRequest.post(`/sync/student_crud_skill`,payload)
      await elasticSearchSyncRequest.post(`/sync/skill_master`,payload)
      return true
    } catch (error) {
      //console.log('Error in publishing role', error)
      return error
    }
}

export const updateStudent = data => async (dispatch, getState) => {
  const state1 = getState()
  try {
    const response = await studentRequest.put(
      `/students/${state1?.auth?.studentId}/updateStudent`,
      data
    )
    if (
      response?.data?.data &&
      !response.data?.data?.lastAppliedEventIds?.length
    ) {
      dispatch(setExternalAppliedEventData(null))
    }
  } catch (error) {
    //console.log('Error in publishing role', error)
  }
}

export const getCollege = () => async (dispatch, getState) => {
  const state = getState()
  const instituteId = state?.studentData?.studentDetails?.instituteCampusId
  try {
    if (instituteId) {
      const response = await instituteRequest.get(
        `/institutes/instituteCampus/${instituteId}`
      )
      dispatch(setCampusDetails(response.data.data))
    }
  } catch (error) {
    //console.log('Error in getting institute data', error)
  }
}

export const changePassword = (userId, payload) => async dispatch => {
 
    try {
      await authRequest.patch(`/user/${userId}/password`, payload)
      //console.log('Password Changed Successfully')
      return true
    } catch (error) {
      //console.log('Error in Password Changing', error)
      return error
    }

}

export const getCities = searchValue => async (dispatch, getState) => {
  let SearchKey = searchValue ? `&search=${searchValue}` : ''
  //console.log(SearchKey)
  try {
    const result = await searchRequest.get(
      `cities?pageLimit=50&currentPage=1${SearchKey}`
    )
    dispatch(setListOfPerfCity(result?.data?.data))

    return result?.data?.data
  } catch (error) {
    //console.log('Error in getting list of degree =>', error?.message)
    dispatch(setListOfPerfCity([]))
  }
}

export const getDegreeData =
  (searchValue, degreeType) => async (dispatch, getState) => {
    try {
      let search = searchValue ? `&search=${searchValue}` : ''
      let degreeOption
      if (degreeType === 'ug' || degreeType === 'pg' || degreeType === 'phd') {
        degreeOption = degreeType.toUpperCase()
      }
      let degree = degreeOption ? `&degreeType=${degreeOption}` : ''
      const data = await instituteRequest.get(
        `/institutes/search/degrees?pageLimit=500&pageNo=0${search}${degree}`
      )
      return data?.data?.data
    } catch (error) {
      //console.log('Error in getting degree data', error)
    }
  }

// Institute Campus

export const getListOfAllColleges =
  searchCollege => async (dispatch, getState) => {
    let search = searchCollege ? `&search=${searchCollege}` : ''
    try {
      const result = await instituteRequest.get(
        `/institutes/crud/college?isActive=true&pageLimit=40&pageNo=0&isCampus=true${search}`
      )
      dispatch(setListOfCollegeData(result?.data?.data))
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setListOfCollegeData({}))
    }
  }

export const getListOfAllCollegesCurCourse =
  ({
    searchCollege,
    stateId,
    cityId,
    state,
    city,
    isCurrentCourse,
    isPaginate = true,
  }) =>
  async (dispatch, getState) => {
    let search = searchCollege ? `&search=${searchCollege}` : ''
    let body = {}
    let pagination = isPaginate ? `pageNo=0&pageLimit=50` : ''

    try {
      const result = await instituteRequest.get(
        `/institutes/search/instituteCampuses?${pagination}${search}${
          stateId ? `&stateId=${stateId}` : ''
        }${cityId ? `&cityId=${cityId}` : ''}${state ? `&state=${state}` : ''}${
          city ? `&city=${city}` : ''
        }`,
        body
      )
      if (isCurrentCourse) {
        dispatch(setListOfCollege(result?.data?.data))
      } else {
        dispatch(setListOfCollegeData(result?.data?.data))
      }
      return result
    } catch (error) {
      //console.log(error)
      ErrorMessage(error?.message)
      dispatch(setListOfCollege({}))
      dispatch(setListOfCollegeData(result?.data?.data))
    }
  }

export const getCorporateList =
  (searchValue, pageLimit = 10, isDispatch = true) =>
  async (dispatch, getState) => {
    let SearchKey = searchValue ? `&search=${searchValue}` : ''
    let query = `pageLimit=${pageLimit}&pageNo=0${SearchKey}`
    try {
      const result = await studentRequest.get(`/students/crud/company?${query}`)
      if (isDispatch) {
        dispatch(setCorporateMasterList(result?.data?.data?.result))
      }
      return result
    } catch (error) {
      ErrorMessage(error?.message)
      dispatch(setCorporateMasterList({}))
    }
  }

export const isCorporateMasterExist = async searchValue => {
  let SearchKey = searchValue ? `&search=${searchValue}` : ''
  let query = `pageLimit=10&pageNo=0${SearchKey}`
  try {
    const result = await studentRequest.get(`/students/crud/company?${query}`)
    if (result?.data?.data?.count > 0) {
      return 1
    } else {
      return 0
    }
  } catch (error) {
    return 1
  }
}
